import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Share } from '@capacitor/share';

@Component({
  selector: 'app-socialicon',
  templateUrl: './socialicon.page.html',
  styleUrls: ['./socialicon.page.scss'],
})
export class SocialiconPage {

  shareUrl = 'https://yourwebsite.com';
  shareText = 'Check out this app!';
  shareTitle = 'Share';

  constructor(private modalCtrl: ModalController) {}

  close() {
    this.modalCtrl.dismiss();
  }

  async whatsapp() {
    await Share.share({
      title: this.shareTitle,
      text: this.shareText,
      url: this.shareUrl,
      dialogTitle: 'Share via WhatsApp',
    });
  }

  async facebook() {
    await Share.share({
      title: this.shareTitle,
      text: this.shareText,
      url: this.shareUrl,
      dialogTitle: 'Share on Facebook',
    });
  }

  async email() {
    await Share.share({
      title: this.shareTitle,
      text: this.shareText,
      url: this.shareUrl,
      dialogTitle: 'Share via Email',
    });
  }

  async instagra() {
    await Share.share({
      title: this.shareTitle,
      text: this.shareText,
      url: this.shareUrl,
      dialogTitle: 'Share on Instagram',
    });
  }
}
